module["exports"] = ["np", "com", "info", "net", "org"];